export default "__VITE_ASSET__DTKnAn4q__"